import React from 'react';
import { Grid } from '@material-ui/core';
import TextoEnriquecido from '../textoEnriquecido/TextoEnriquecido';

/**
 * @function TextoEstatico
 * Función compuesta por un Grid y el componente TextoEnriquecido
 * El componente en si recibe las propiedades de cada atributo a través de las props
 * Se incluye el componente TextoEnriquecido para poder insertar texto con formato HTML
 * @param props Recibe por parámetro los atributos
 */
export default function TextoEstatico(props) {
    return (
        <Grid
            item
            id={props.idGrid}
            className={props.estiloGrid}
        >
            <TextoEnriquecido
                id={props.id}
                name={props.name}
                className={props.estiloTexto}
                texto={props.text}
            />
        </Grid>
    )
}